(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-upsell"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-upsell')) {
    customElements.define(
      'product-upsell',
      class ProductUpsell extends HTMLElement {
        constructor() {
          super();
          this.checkboxes = Array.from(this.querySelectorAll('.product-upsell__checkbox'));
          this.totalPriceEl = this.querySelector('[data-total-price]');
          this.submitButton = this.querySelector('[data-add-button]');
          this.buttonTextEl = this.querySelector('[data-button-text]');
          this.errorEl = this.querySelector('[data-error]');
          this.anchorItem = this.querySelector('.product-upsell__item--anchor');
          this.anchorPrice = Number(this.anchorItem?.dataset.price || 0);
          this.defaultButtonText = this.buttonTextEl ? this.buttonTextEl.textContent : '';
          this.formatter = new Intl.NumberFormat(this.dataset.locale || document.documentElement.lang, {
            style: 'currency',
            currency: this.dataset.currency,
          });
        }

        connectedCallback() {
          this.checkboxes.forEach((checkbox) => {
            checkbox.addEventListener('change', this.updateTotal.bind(this));
          });
          this.submitButton?.addEventListener('click', this.onSubmit.bind(this));
          this.updateTotal();
        }

        updateTotal() {
          const selectedTotal = this.checkboxes
            .filter((checkbox) => checkbox.checked)
            .reduce((sum, checkbox) => sum + Number(checkbox.dataset.price || 0), 0);
          const total = this.anchorPrice + selectedTotal;

          if (this.totalPriceEl) {
            this.totalPriceEl.textContent = this.formatter.format(total / 100);
          }
        }

        getMainVariantId() {
          const input = document.querySelector('.product-variant-id');
          return input && input.value ? input.value : this.dataset.fallbackVariantId;
        }

        async onSubmit() {
          if (this.submitButton.getAttribute('aria-busy') === 'true') return;

          this.hideError();

          const mainVariantId = this.getMainVariantId();
          if (!mainVariantId) return;

          const items = [{ id: mainVariantId, quantity: 1 }];
          this.checkboxes.forEach((checkbox) => {
            if (checkbox.checked) {
              items.push({ id: checkbox.dataset.variantId, quantity: 1 });
            }
          });

          this.submitButton.setAttribute('aria-busy', 'true');
          this.submitButton.disabled = true;

          try {
            const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                items,
                sections: ['cart-drawer', 'cart-icon-bubble'],
                sections_url: window.location.pathname,
              }),
            });

            const result = await response.json();

            if (!response.ok) {
              throw new Error(result.description || result.message);
            }

            document.dispatchEvent(
              new CustomEvent('cart:build', {
                bubbles: true,
                detail: { source: 'product-upsell', cart: result },
              })
            );

            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && result.sections && typeof cartDrawer.renderContents === 'function') {
              cartDrawer.renderContents(result);
            }

            if (this.buttonTextEl) {
              this.buttonTextEl.textContent = this.dataset.addedText || this.defaultButtonText;
            }
          } catch (error) {
            this.showError(error.message || this.dataset.errorText);
          } finally {
            this.submitButton.removeAttribute('aria-busy');
            this.submitButton.disabled = false;
          }
        }

        showError(message) {
          if (!this.errorEl) return;
          this.errorEl.textContent = message;
          this.errorEl.hidden = false;
        }

        hideError() {
          if (!this.errorEl) return;
          this.errorEl.hidden = true;
          this.errorEl.textContent = '';
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
